export default "__VITE_ASSET__DNr5zpE$__"